module.exports = __webpack_public_path__ + "img/bg_HAI.1827fe76.png";